module.exports = __webpack_public_path__ + "media/application/images/business-modelling/welcome-c53ff072047186c5c3f26081ff552750.jpg";